import { extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import zhCN from 'vee-validate/dist/locale/zh_CN.json'
import * as rules from 'vee-validate/dist/rules'
import Vue from 'vue'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

localize('zh_CN', zhCN)

const messages = {
  required: field => `*请输入${field}`
}
const dictionary = {
  zh_CN: {
    messages
  }
}
localize(dictionary)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

extend('phone', (value,args) => {
  if (args[0]=="+86"){
    const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
    if (reg.test(value)) {
      return true
    }
    return '*请输入正确的手机号码'
  }
  else{
    return true

  }

})

extend('english', (value) => {
  
  const reg = /^[a-zA-Z]+$/
  if (reg.test(value.trim())) {
    return true
  }
  return '*请输入拼音姓氏'
})
